<template>
    <div>
        <template v-if="!newVersion">
            <md-field :class="fieldClass">
                <label>
                    {{ $t('registration.entity-type') }}
                </label>

                <md-select
                    v-model="entity_type_id"
                    :name="name"
                    :disabled="disabled"
                    @md-selected="selected"
                    dusk="country-input"
                >
                    <md-option
                        v-for="entityType in entityTypes"
                        :key="entityType.id"
                        :value="entityType.id"
                    >
                        {{ entityType.name }}
                    </md-option>
                </md-select>

                <span class="md-error">
                    {{ errors && errors.length ? errors[0] : '' }}
                </span>
            </md-field>
        </template>
        <template v-else>
            <label class="block ml-1 mb-1 text-xs font-medium text-gray-900">
                {{ $t('registration.entity-type') }}
            </label>
            <md-menu md-direction="bottom-start" class="entity-type-selector block bg-white border border-gray-200 text-gray-900 text-sm rounded-md focus:ring-blue-900 block w-full p-1.5 placeholder:italic" :class="{ 'border-red-500': !!(errors && errors.length) }">
                <md-button md-menu-trigger class="!py-0 !min-w-8 !px-1 nv-button text-sm font-normal h-auto w-full normal-case !text-primary-dark-50">
                    <span class="flex items-center justify-between w-full" :class="{ 'text-red-500': !!(errors && errors.length) }">
                        <span>{{ currentLabel || $t('registration.select-entity-type') }}</span>
                        <svg class="w-4 h-4 ml-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </span>
                </md-button>
                <md-menu-content>
                    <md-menu-item
                        v-for="entityType in entityTypes"
                        :key="entityType.id"
                        @click="choose(entityType)"
                    >
                        {{ entityType.name }}
                    </md-menu-item>
                </md-menu-content>
            </md-menu>
            <span class="md-error">
                {{ errors && errors.length ? errors[0] : '' }}
            </span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        fieldClass: {
            type: Object,
            default: () => {{}}
        },
        errors: {
            type: Array,
            default: () => []
        },
        name: {
            type: String,
            default: 'country_id'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        entityTypeId: {
            type: Number,
            default: null
        },
        newVersion: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            entity_type_id: null,
            entityTypes: false,
        };
    },
    computed: {
        currentLabel() {
            const list = Array.isArray(this.entityTypes) ? this.entityTypes : [];
            const found = list.find(e => e && e.id === this.entity_type_id);
            return found ? found.name : '';
        }
    },
    watch: {
        entityTypeId(value) {
            if (this.entityTypeId) {
                this.entity_type_id = this.entityTypeId;
            }
        },
    },
    mounted() {
        if (this.entityTypeId) {
            this.entity_type_id = this.entityTypeId;
        }

        this.initSource();
    },
    methods: {
        initSource() {
            axios.get('/api/entity-types').then((response) => {
                this.entityTypes = response.data;
            });
        },
        choose(entityType) {
            if (entityType && typeof entityType.id !== 'undefined') {
                this.entity_type_id = entityType.id;
                this.$emit('on-change', entityType.id);
            }
        },
        selected(value) {
            this.$emit('on-change', value);
        }
    }
};
</script>
<style lang="scss">
.entity-type-selector {
    .md-ripple {
        justify-content: flex-start;
        padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/EntityTypeSelector.vue